// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { NotificationTypeDto } from '../models';
// @ts-ignore
import type { NotificationsListDto } from '../models';
/**
 * NotificationsApi - axios parameter creator
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<NotificationTypeDto>} [notificationType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications: async (notificationType?: Array<NotificationTypeDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (notificationType) {
                localVarQueryParameter['notificationType'] = notificationType.join(COLLECTION_FORMATS.csv);
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Array<NotificationTypeDto>} [notificationType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotifications(notificationType?: Array<NotificationTypeDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationsListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotifications(notificationType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.getNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationsApi - factory interface
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * 
         * @param {Array<NotificationTypeDto>} [notificationType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications(notificationType?: Array<NotificationTypeDto>, options?: RawAxiosRequestConfig): AxiosPromise<NotificationsListDto> {
            return localVarFp.getNotifications(notificationType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationsApi - interface
 */
export interface NotificationsApiInterface {
    /**
     * 
     * @param {Array<NotificationTypeDto>} [notificationType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNotifications(notificationType?: Array<NotificationTypeDto>, options?: RawAxiosRequestConfig): AxiosPromise<NotificationsListDto>;

}

/**
 * NotificationsApi - object-oriented interface
 */
export class NotificationsApi extends BaseAPI implements NotificationsApiInterface {
    /**
     * 
     * @param {Array<NotificationTypeDto>} [notificationType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNotifications(notificationType?: Array<NotificationTypeDto>, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getNotifications(notificationType, options).then((request) => request(this.axios, this.basePath));
    }
}

